const envi = process.env

var crypto = require('crypto'),
    algorithm = 'aes-256-ctr',
    password = 'd6F3Efeq'

const encrypt = (text)=>{
  let cipher = crypto.createCipher(algorithm, password)
  let crypted = cipher.update(text, 'utf8', 'hex')
  crypted += cipher.final('hex');
  return crypted;
}
 
const decrypt = (text)=>{
  let decipher = crypto.createDecipher(algorithm, password)
  let dec = decipher.update(text, 'hex', 'utf8')
  dec += decipher.final('utf8');
  return dec;
}

const notifCfg = (page)=>{
  return {
    options:{
      base:{
        position:'topCenter',
        progressBarColor:'rgb(0, 255, 184)',
        timeout:5000
      }
    }
  }
}

export {
  envi,
	encrypt,
  decrypt,
  notifCfg
}